import template from './scoresheet_page.html'
import './scoresheet_page.css'

export default {
  template,
  controller: 'scoresheetPageController as scoresheetPage'
}
